import pluralize from 'pluralize';

import {
  BlueSquare,
  GreenCircle,
} from 'approot/shared/differentiation/differentiation.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import TeachingLearningSequencePaywallButtons from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence-paywall-buttons';
import { ASSESSMENT, LESSON } from 'global/constants';
import BlackDiamond from '../differentiation/black-diamond';
import InlineSvg from '../inline-svg/inline-svg';
import * as Styled from './teaching-learning-sequence-paywall.style';

const TeachingLearningSequencePaywall = ({
  isAccountExpired,
  totalGreenActivities,
  totalBlueActivities,
  totalBlackActivities,
  totalStimulus,
  contentId,
  contentType,
}: {
  isAccountExpired: boolean;
  totalGreenActivities: number;
  totalBlueActivities: number;
  totalBlackActivities: number;
  totalStimulus: number;
  contentId: number;
  contentType: typeof LESSON | typeof ASSESSMENT;
}) => {
  return (
    <Styled.PaywallContainer>
      <Styled.PaywallHeading>
        {isAccountExpired ? 'Reactivate your account' : 'Join or sign in'} to
        unlock the rest of this lesson’s differentiated activities
      </Styled.PaywallHeading>

      {totalGreenActivities > 0 && (
        <Styled.PaywallSection>
          <GreenCircle $width={32} $height={32} $marginRight={spacing16} />
          <div>
            <Styled.PaywallSectionTitle>
              {totalGreenActivities} Core{' '}
              {pluralize('Activities', totalGreenActivities)}
            </Styled.PaywallSectionTitle>
            <Styled.PaywallText>
              These are central to the focus question or learning intention and
              include surface, deeper and transfer of learning.
            </Styled.PaywallText>
          </div>
        </Styled.PaywallSection>
      )}

      {totalBlueActivities > 0 && (
        <Styled.PaywallSection>
          <BlueSquare $width={32} $height={32} $marginRight={spacing16} />
          <div>
            <Styled.PaywallSectionTitle>
              {totalBlueActivities} Deeper Learning{' '}
              {pluralize('Activities', totalBlueActivities)}
            </Styled.PaywallSectionTitle>
            <Styled.PaywallText>
              These take thinking to the next level and require more time,
              effort and sometimes research.
            </Styled.PaywallText>
          </div>
        </Styled.PaywallSection>
      )}

      {totalBlackActivities > 0 && (
        <Styled.PaywallSection>
          <BlackDiamond size={32} scale marginRight={spacing16} />
          <div>
            <Styled.PaywallSectionTitle>
              {totalBlackActivities} Challenging{' '}
              {pluralize('Activities', totalBlackActivities)}
            </Styled.PaywallSectionTitle>
            <Styled.PaywallText>
              These require extended critical and creative thinking.
            </Styled.PaywallText>
          </div>
        </Styled.PaywallSection>
      )}

      {totalStimulus > 0 && (
        <Styled.PaywallSection>
          <Styled.PaywallGreyCircle>
            <InlineSvg id="video" width={16} height={16} />
          </Styled.PaywallGreyCircle>
          <div>
            <Styled.PaywallSectionTitle>
              {totalStimulus} Stimulus
            </Styled.PaywallSectionTitle>
            <Styled.PaywallText>
              Quality videos, interactives, eBooks and more are built into our
              lessons to support learning.
            </Styled.PaywallText>
          </div>
        </Styled.PaywallSection>
      )}

      <Styled.PaywallSection>
        <Styled.PaywallGreyCircle>
          <InlineSvg id="icon_download" width={16} height={16} />
        </Styled.PaywallGreyCircle>
        <div>
          <Styled.PaywallSectionTitle>
            Downloadable Program
          </Styled.PaywallSectionTitle>
          <Styled.PaywallText>
            Every unit and lesson comes with a downloadable fully editable
            Program.
          </Styled.PaywallText>
        </div>
      </Styled.PaywallSection>

      <TeachingLearningSequencePaywallButtons
        isAccountExpired={isAccountExpired}
        contentId={contentId}
        contentType={contentType}
      />
    </Styled.PaywallContainer>
  );
};

export default TeachingLearningSequencePaywall;
